import { render } from "./ui-tags-item.vue?vue&type=template&id=06c14e11&scoped=true&ts=true"
import script from "./ui-tags-item.vue?vue&type=script&lang=ts"
export * from "./ui-tags-item.vue?vue&type=script&lang=ts"

import "./ui-tags-item.vue?vue&type=style&index=0&id=06c14e11&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c14e11"]])

export default __exports__